// @systeme: interface
import { useState, type FormEvent } from 'react';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { Link as LienRouteur, useSearchParams } from 'react-router';
import { FormulaireAuth } from '../composants/FormulaireAuth';
import { messageDe } from '../composants/Messages';
import { api } from '../lib/api';

export function Reinitialisation() {
  const [parametres] = useSearchParams();
  const jeton = parametres.get('jeton') ?? '';
  const [motDePasse, setMotDePasse] = useState('');
  const [erreur, setErreur] = useState<string | undefined>();
  const [fait, setFait] = useState(false);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setErreur(undefined);
    setEnCours(true);
    try {
      await api.auth.reinitialisation({ jeton, motDePasse });
      setFait(true);
    } catch (err) {
      setErreur(messageDe(err));
    } finally {
      setEnCours(false);
    }
  }

  return (
    <FormulaireAuth
      titre="Choisis un nouveau mot de passe"
      erreur={erreur}
      onSoumettre={soumettre}
      pied={
        <Link component={LienRouteur} to="/connexion">
          {fait ? 'Me connecter' : 'Retour à la connexion'}
        </Link>
      }
    >
      {fait ? (
        <Typography>C’est fait. Tu peux te connecter avec ton nouveau mot de passe.</Typography>
      ) : jeton === '' ? (
        <Typography>
          Ce lien est incomplet. Demande un nouveau mot de passe, ça prend dix secondes.
        </Typography>
      ) : (
        <>
          <TextField
            label="Nouveau mot de passe (8 caractères ou plus)"
            type="password"
            autoComplete="new-password"
            value={motDePasse}
            onChange={(e) => setMotDePasse(e.target.value)}
            required
          />
          <Button type="submit" variant="contained" size="large" disabled={enCours}>
            Enregistrer
          </Button>
        </>
      )}
    </FormulaireAuth>
  );
}
